import React, { FC, useEffect, useState } from 'react';
import { ExpandableInput } from 'components/atoms/input';
import { useTranslation } from 'hooks/use-translation';

interface NotesInputProps {
  value?: string;
  disabled?: boolean;
  onUpdate: (value?: string) => void;
}

export const NotesInput: FC<NotesInputProps> = ({
  value,
  disabled,
  onUpdate,
}) => {
  const placeholderText = useTranslation('timesheets.placeholders.notes');
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <ExpandableInput
      placeholder={placeholderText}
      value={localValue}
      disabled={disabled}
      contentMaxWidth="300px"
      onChange={(e) => {
        setLocalValue(e.target.value);
      }}
      onBlur={() => onUpdate(localValue)}
    />
  );
};
